
import { useMutation } from "@tanstack/react-query";
import { FunctionalGraphItem } from "./use-get-functional-graph-service";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export async function updateFunctionalNode(payload: {
  label: string;
  data: Omit<FunctionalGraphItem, "id">;
}, uuid: string, id: string, token: string): Promise<FunctionalGraphItem & { label: string }> {
  const url = `${config.isometricApiUrl}/functional-graph/${uuid}/update-node/${id}`;
  try {
    const response = await apiFetch(url, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json(); // Parse the JSON response
    return { ...data, label: payload.label };
  } catch (error) {
    console.error("Error:", error); // Handle errors
    throw error;
  }
}

export const useUpdateFunctionalNode = (onSettled?: (res: FunctionalGraphItem & { label: string } | undefined, error: Error | null) => void) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
                  body: {
                    label: string;
                    data: Omit<FunctionalGraphItem, "id">;
                  },
                  id: string,
                  uuid: string
                }) => {
            const headers = getAuthHeaders();
                  const token = headers.Authorization.replace('Bearer ', '');
                  return updateFunctionalNode(payload.body, payload.uuid, payload.id, token);
            },
      
      onSettled
  });
};
